import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SettingsNotificationModal from '../../components/VenueDashboard/components/SettingsNotificationModal';
import {
  buildVenueDashboardPaymentsUrl,
  persistVenueDashboardPaymentsSection,
  resolveStripeConnectReturnCopy
} from '../../utils/stripeConnectNavigation';
import { clearCachedStripeConnectStatus } from '../../utils/stripeConnectStatus';

/**
 * Stripe OAuth return page — users land here after the backend callback redirect.
 * Avoids exposing API JSON/errors on execute-api URLs.
 */
const StripeConnectCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showModal, setShowModal] = useState(true);

  const venueId = searchParams.get('venueId') || searchParams.get('venue_id') || '';
  const result = searchParams.get('stripe_connect') || '';
  const message = searchParams.get('stripe_connect_message') || '';

  const modalCopy = useMemo(
    () => resolveStripeConnectReturnCopy({ result, message }),
    [result, message]
  );

  useEffect(() => {
    if (venueId) {
      persistVenueDashboardPaymentsSection(venueId);
      if (result === 'success') {
        clearCachedStripeConnectStatus(venueId);
      }
    }
  }, [venueId, result]);

  const handleClose = () => {
    setShowModal(false);
    navigate(buildVenueDashboardPaymentsUrl(venueId), { replace: true });
  };

  if (!result) {
    return (
      <div className="stripe-connect-callback-page">
        <SettingsNotificationModal
          show
          type="error"
          title="Invalid return from Stripe"
          message="This page is only used after connecting Stripe. Open your venue dashboard and go to Settings → Payments."
          onClose={() => navigate('/venue-dashboard', { replace: true })}
        />
      </div>
    );
  }

  return (
    <div className="stripe-connect-callback-page">
      <SettingsNotificationModal
        show={showModal}
        type={modalCopy.type}
        title={modalCopy.title}
        message={modalCopy.message}
        onClose={handleClose}
      />
    </div>
  );
};

export default StripeConnectCallbackPage;
